import React, { Component } from 'react';
import * as Cookies from "es-cookie";
import { Row, Card, Image, Col, Container, Accordion, Table } from 'react-bootstrap';
import Chemistry from '../../../images/chemistry_icon.png';
import Zoology from '../../../images/zoology_icon.png';
import Physics from '../../../images/physics_icon.png';
import Maths from '../../../images/maths_icon.png';
import Botany from '../../../images/botany_icon.png';
import General from '../../../images/General.png';

import './_instituteRevisonMaterials.scss';
import PDFModel, { isFileAvailable } from './pdfShowModel';
import MultiSelectDropdown from './MultiSelectDropdown';

const SUBJECT_ICONS = {
    "0": General,
    "1": Botany,
    "2": Physics,
    "3": Chemistry,
    "4": Maths,
    "5": Zoology,
    "6": Botany,
};

const SUBJECT_NAMES = {
    "0": "General",
    "1": "Botany",
    "2": "Physics",
    "3": "Chemistry",
    "4": "Mathematics",
    "5": "Zoology",
    "6": "Biology",
};

class InstituteRevisionMaterialsHome extends Component {
    constructor(props) {
        super(props);

        // Table-view filters default to "all selected" (all derived from this institute's
        // data for the student's own exam — materials are already exam-scoped by the backend).
        const allClasses = this.distinctClasses(props);
        const allSubjects = this.distinctSubjects(props);
        const allChapters = this.availableChaptersFrom(props, allClasses, allSubjects);

        this.state = {
            getSubjectsArr: [],
            selectedSubjectVal: "",
            classData: { value: 1, label: 'Class-XI' },
            selectedSubjectClassVal: [],
            currentActiveKey: "",
            modalShow: false,
            file_path: "",
            file_name: "",
            viewMode: "card",
            filterClass: allClasses,
            filterSubject: allSubjects,
            filterChapter: allChapters,
            searchText: "",
            currentPage: 1,
            pageSize: 10

        }
    }

    materialsFrom = (props) => {
        const p = props || this.props;
        return p.instituteRevisionMaterils && p.instituteRevisionMaterils.length > 0 ? p.instituteRevisionMaterils : [];
    }

    distinctClasses = (props) => {
        const materials = this.materialsFrom(props);
        return [...new Set(materials.map((m) => String(m.class_id)))].filter((c) => c && c != "null")
            .sort((a, b) => Number(a) - Number(b));
    }

    distinctSubjects = (props) => {
        const materials = this.materialsFrom(props);
        return [...new Set(materials.map((m) => String(m.subject_id)))]
            .sort((a, b) => Number(a) - Number(b));
    }

    // Distinct non-empty chapter names for the given class/subject selections
    availableChaptersFrom = (props, classSel, subjectSel) => {
        const materials = this.materialsFrom(props);
        return [...new Set(
            materials
                .filter((m) => classSel.includes(String(m.class_id)) && subjectSel.includes(String(m.subject_id)))
                .map((m) => m.chapter_name)
                .filter((c) => c && c.trim() !== "")
        )];
    }

    subjectNameById = (subject_id) => {
        if (SUBJECT_NAMES[String(subject_id)]) return SUBJECT_NAMES[String(subject_id)];
        const found = this.state.getSubjectsArr.find((s) => s.id == subject_id);
        return found ? found.subject : "-";
    }

    className = (class_id) => (class_id == "1" ? "XI" : class_id == "2" ? "XII" : "-");

    componentDidMount = () => {
        if (this.props.getSubjectOrder != undefined || this.props.getSubjectOrder != null) {
            let selectedSubject = "";
            const getSubjects = this.props.getSubjectOrder.map((gmap, index) => {
                if (index == 0) {
                    selectedSubject = gmap.id
                    return { ...gmap, active: "active" }
                }
                else {
                    return { ...gmap, active: "" }
                }
            })

            getSubjects.push({ id: 0, subject: "General", active: "" });

            let selectedSubjectClassVal = [];

            if (this.props.instituteRevisionMaterils != undefined && this.props.instituteRevisionMaterils.length > 0) {
                let selectedChaptersClassData = this.props.instituteRevisionMaterils.filter((item) => item.subject_id == selectedSubject && item.class_id == "1");

                let uniqueChapters = selectedChaptersClassData.filter((item1, index, array) => {
                    return array.findIndex((item2) => item2.chapter_id == item1.chapter_id) == index;
                });

                if (uniqueChapters.length > 0) {
                    uniqueChapters.map((item1) => {
                        let filesData = selectedChaptersClassData.filter((item2) => item2.chapter_id == item1.chapter_id);
                        selectedSubjectClassVal.push({ chapter_id: item1.chapter_id, chapter_name: item1.chapter_name, filesData: filesData })
                    })
                }
            }
            this.setState({
                getSubjectsArr: getSubjects,
                selectedSubjectVal: selectedSubject,
                selectedSubjectClassVal: selectedSubjectClassVal,
            });
        }
    }

    toggle = (index) => {
        if (this.state.currentActiveKey != index.toString()) {
            this.setState({ currentActiveKey: index })
        }
        else {
            this.setState({ currentActiveKey: "" })
        }

    }

    handleSelect = (subid) => {
        const getSubjects = this.state.getSubjectsArr.map((gmap, index) => {
            if (gmap.id == subid) {
                return { ...gmap, active: "active" }
            }
            else {
                return { ...gmap, active: "" }
            }
        });
        this.toggle(this.state.currentActiveKey)

        this.setState({
            getSubjectsArr: getSubjects,
            selectedSubjectVal: subid,
        });
        this.updateSelectedData(subid, this.state.classData.value);
    }

    updateSelectedData = (subject_id, class_id) => {
        let selectedSubjectClassVal = [];
        let selectedChaptersClassData = this.props.instituteRevisionMaterils.filter((item) => item.subject_id == subject_id && item.class_id == class_id);

        let uniqueChapters = selectedChaptersClassData.filter((item1, index, array) => {
            return array.findIndex((item2) => item2.chapter_id == item1.chapter_id) == index;
        });

        if (uniqueChapters.length > 0) {
            uniqueChapters.map((item1) => {
                let filesData = selectedChaptersClassData.filter((item2) => item2.chapter_id == item1.chapter_id);
                selectedSubjectClassVal.push({ chapter_id: item1.chapter_id, chapter_name: item1.chapter_name, filesData: filesData })

            })

        }
        this.setState({
            selectedSubjectClassVal: selectedSubjectClassVal,
        });
    }

    selectHandleInputChange = (evalue) => {
        const value = evalue
        let labelval = ""

        if (value == "1") {
            labelval = "Class  XI"
        } else {
            labelval = "Class  XII"
        }

        this.updateSelectedData(this.state.selectedSubjectVal, value);
        this.setState({
            classData: {
                value: value,
                label: labelval
            },
            currentActiveKey: ""
        })
    }

    renderFileCard = (item, key) => (
        <Col md={6} lg={4} className='mt-3' key={key}>
            <div className='rm-file-card' onClick={() => this.setState({ modalShow: true, file_path: item.file_path, file_name: item.file_name })}>
                <div className='rm-file-icon'>
                    <i className="fas fa-file-pdf"></i>
                </div>
                <div className='rm-file-info'>
                    <p className='rm-file-name'>{item.file_name}</p>
                    <span className='rm-file-action'>View PDF <i className="fas fa-arrow-right ml-1"></i></span>
                </div>
            </div>
        </Col>
    )

    renderFilesGrid = (filesData) => (
        <Row>
            {filesData != null && filesData.length > 0 ?
                filesData.map((item, idx) => this.renderFileCard(item, idx))
                : (<Col sm={12}><p className='rm-empty-inline'>Coming Soon...</p></Col>)
            }
        </Row>
    )

    // Cascading filters: changing Class or Subject re-selects all chapters available for the
    // new selection (default "all selected"). Any filter change returns to page 1.
    handleClassFilter = (selected) => {
        this.setState({ filterClass: selected, filterChapter: this.availableChaptersFrom(this.props, selected, this.state.filterSubject), currentPage: 1 });
    }
    handleSubjectFilter = (selected) => {
        this.setState({ filterSubject: selected, filterChapter: this.availableChaptersFrom(this.props, this.state.filterClass, selected), currentPage: 1 });
    }
    handleChapterFilter = (selected) => this.setState({ filterChapter: selected, currentPage: 1 });

    handleSearch = (value) => this.setState({ searchText: value, currentPage: 1 });

    goToPage = (page) => this.setState({ currentPage: page });

    handlePageSize = (size) => this.setState({ pageSize: size, currentPage: 1 });

    // Page-number list with ellipsis: 1 … 4 5 6 … 20
    pageNumbers = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        const pages = [1];
        const left = Math.max(2, current - 1);
        const right = Math.min(total - 1, current + 1);
        if (left > 2) pages.push("…");
        for (let p = left; p <= right; p++) pages.push(p);
        if (right < total - 1) pages.push("…");
        pages.push(total);
        return pages;
    };

    renderTableView = () => {
        const materials = this.props.instituteRevisionMaterils != undefined && this.props.instituteRevisionMaterils.length > 0
            ? this.props.instituteRevisionMaterils
            : [];

        if (materials.length == 0) {
            return (
                <Row className='mt-4'>
                    <Col sm={12}>
                        <div className='rm-empty-state'>
                            <i className="fas fa-folder-open"></i>
                            <h6>No revision materials available yet</h6>
                        </div>
                    </Col>
                </Row>
            );
        }

        const { filterClass, filterSubject, filterChapter, searchText } = this.state;

        // Dropdown options — all derived from THIS institute's data for the student's exam.
        const classOptions = this.distinctClasses(this.props)
            .map((c) => ({ value: c, label: `Class ${this.className(c)}` }));

        const subjectOptions = this.distinctSubjects(this.props)
            .map((s) => ({ value: s, label: this.subjectNameById(s) }));

        const chapterOptions = this.availableChaptersFrom(this.props, filterClass, filterSubject)
            .map((c) => ({ value: c, label: c }));

        // Apply all active filters to the rows. A row passes the chapter filter when it
        // has no chapter (e.g. General) or its chapter is in the selected set.
        const search = (searchText || "").trim().toLowerCase();
        const filtered = materials.filter((m) => {
            const passesFilters =
                filterClass.includes(String(m.class_id)) &&
                filterSubject.includes(String(m.subject_id)) &&
                (!m.chapter_name || m.chapter_name.trim() === "" || filterChapter.includes(m.chapter_name));
            if (!passesFilters) return false;
            if (search === "") return true;
            const haystack = [
                this.subjectNameById(m.subject_id),
                `class ${this.className(m.class_id)}`,
                m.chapter_name || "",
                m.file_name || ""
            ].join(" ").toLowerCase();
            return haystack.includes(search);
        });

        // Pagination
        const { pageSize } = this.state;
        const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
        const currentPage = Math.min(this.state.currentPage, totalPages);
        const startIndex = (currentPage - 1) * pageSize;
        const pageRows = filtered.slice(startIndex, startIndex + pageSize);

        return (
            <React.Fragment>
                <Row className='mt-3 rm-filters'>
                    <Col xs={12} sm={4} className='mb-2'>
                        <MultiSelectDropdown label="Class" options={classOptions} selected={filterClass} onChange={this.handleClassFilter} />
                    </Col>
                    <Col xs={12} sm={4} className='mb-2'>
                        <MultiSelectDropdown label="Subject" options={subjectOptions} selected={filterSubject} onChange={this.handleSubjectFilter} />
                    </Col>
                    <Col xs={12} sm={4} className='mb-2'>
                        <MultiSelectDropdown label="Chapter" options={chapterOptions} selected={filterChapter} onChange={this.handleChapterFilter} />
                    </Col>
                </Row>
                <Row className='mt-2 align-items-center'>
                    <Col xs={12} md={7} lg={6}>
                        <div className='rm-search'>
                            <i className="fas fa-search rm-search-icon"></i>
                            <input
                                type="text"
                                className='rm-search-input'
                                placeholder="Search subject, chapter, file name..."
                                value={searchText}
                                onChange={(e) => this.handleSearch(e.target.value)}
                            />
                            {searchText ? (
                                <i className="fas fa-times rm-search-clear" onClick={() => this.handleSearch("")}></i>
                            ) : ("")}
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={6} className='mt-2 mt-md-0'>
                        <span className='rm-count float-md-right'>
                            <i className="fas fa-layer-group mr-2"></i>
                            {filtered.length} {filtered.length === 1 ? "Material" : "Materials"}
                        </span>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col sm={12}>
                        <div className='rm-table-wrap'>
                            <Table responsive className='rm-table mb-0'>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Subject</th>
                                        <th>Class</th>
                                        <th>Chapter</th>
                                        <th>File Name</th>
                                        <th className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageRows.length > 0 ? pageRows.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className='rm-td-index'>{startIndex + idx + 1}</td>
                                            <td>
                                                <span className='rm-subject-cell'>
                                                    <span className='rm-subject-dot'>
                                                        <i className="fas fa-book"></i>
                                                    </span>
                                                    <span className='rm-subject-name'>{this.subjectNameById(item.subject_id)}</span>
                                                </span>
                                            </td>
                                            <td><span className='rm-badge rm-badge-class'>Class {this.className(item.class_id)}</span></td>
                                            <td>{item.chapter_name ? item.chapter_name : "-"}</td>
                                            <td>
                                                <span className='rm-file-cell'>
                                                    <i className="fas fa-file-pdf rm-file-cell-icon"></i>
                                                    {item.file_name}
                                                </span>
                                            </td>
                                            <td className='text-center'>
                                                {isFileAvailable(item.file_path) ? (
                                                    <div className='rm-action-btns'>
                                                        <button type="button" className="rm-table-btn" onClick={() => this.setState({ modalShow: true, file_path: item.file_path, file_name: item.file_name })}>
                                                            <i className="fas fa-eye mr-1"></i> View
                                                        </button>
                                                        <a href={item.file_path} target="_blank" rel="noopener noreferrer" download className="rm-table-btn rm-table-btn-dl">
                                                            <i className="fas fa-download mr-1"></i> Download
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <span className='rm-unavailable'>Unavailable</span>
                                                )}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={6} className='text-center rm-empty-inline'>No materials match the selected filters</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                            {filtered.length > 0 ? (
                                <div className='rm-pager'>
                                    <div className='rm-pager-left'>
                                        <span className='rm-pager-showing'>
                                            Showing {startIndex + 1}&ndash;{Math.min(startIndex + pageSize, filtered.length)} of {filtered.length}
                                        </span>
                                        <span className='rm-pager-rows-label'>Rows:</span>
                                        <select className='rm-pager-rows' value={pageSize} onChange={(e) => this.handlePageSize(parseInt(e.target.value))}>
                                            {[10, 25, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
                                        </select>
                                    </div>
                                    <div className='rm-pager-right'>
                                        <span className={currentPage == 1 ? "rm-page-btn disabled" : "rm-page-btn"} onClick={() => currentPage > 1 && this.goToPage(currentPage - 1)}>
                                            <i className="fas fa-chevron-left"></i>
                                        </span>
                                        {this.pageNumbers(currentPage, totalPages).map((p, i) => (
                                            p === "…" ? (
                                                <span key={`e${i}`} className='rm-page-ellipsis'>…</span>
                                            ) : (
                                                <span key={p} className={currentPage == p ? "rm-page-btn active" : "rm-page-btn"} onClick={() => this.goToPage(p)}>{p}</span>
                                            )
                                        ))}
                                        <span className={currentPage == totalPages ? "rm-page-btn disabled" : "rm-page-btn"} onClick={() => currentPage < totalPages && this.goToPage(currentPage + 1)}>
                                            <i className="fas fa-chevron-right"></i>
                                        </span>
                                    </div>
                                </div>
                            ) : ("")}
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    render() {
        return (
            <Container className='instituteRevisonMaterials'>
                <Row className='align-items-center'>
                    <Col sm={8}>
                        <div className='rm-page-header'>
                            <h4>Revision Materials</h4>
                            <p>Access subject-wise study material shared by your institute</p>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <ul className='list-inline rm-view-toggle float-sm-right'>
                            <li className={this.state.viewMode == "card" ? "active" : ""} onClick={() => this.setState({ viewMode: "card" })}>
                                <i className="fas fa-th-large mr-1"></i> Card View
                            </li>
                            <li className={this.state.viewMode == "table" ? "active" : ""} onClick={() => this.setState({ viewMode: "table" })}>
                                <i className="fas fa-table mr-1"></i> Table View
                            </li>
                        </ul>
                    </Col>
                </Row>

                {this.state.viewMode == "table" ? this.renderTableView() : (
                <React.Fragment>
                <Row>
                    <Col sm={12}>
                        <div className='subject-blocks-view'>
                            {
                                this.state.getSubjectsArr.map((sub, idx) =>
                                    <div className={`rm-subject-card ${sub.active}`} onClick={() => this.handleSelect(sub.id)} key={idx}>
                                        <div className='rm-subject-icon'>
                                            <Image src={SUBJECT_ICONS[sub.id.toString()]} alt={sub.subject} />
                                        </div>
                                        <h6>{sub.subject}</h6>
                                    </div>
                                )
                            }
                        </div>
                    </Col>
                </Row>

                <Row className='align-items-center'>
                    <Col sm={12}>
                        <ul className='list-inline class_type_li mt-4'>
                            <li className={this.state.classData.value == "1" ? "active" : ""} onClick={() => this.selectHandleInputChange("1")}>Class XI</li>
                            <li className={this.state.classData.value == "2" ? "active ml-3" : "ml-3"} onClick={() => this.selectHandleInputChange("2")}>Class XII</li>
                        </ul>
                    </Col>
                </Row>

                {
                    this.state.selectedSubjectClassVal.length > 0 ? (
                        this.state.selectedSubjectClassVal[0].chapter_id == 0 && this.state.selectedSubjectClassVal[0].chapter_name == "" ? (
                            <Row className='mt-2'>
                                <Col sm={12}>
                                    {this.renderFilesGrid(this.state.selectedSubjectClassVal[0].filesData)}
                                </Col>
                            </Row>
                        ) : (
                            <Accordion className='rm-accordion mt-3'>
                                {
                                    this.state.selectedSubjectClassVal.map((item, index) => {
                                        return (
                                            <Card className='rm-chapter-card' key={index}>
                                                <Accordion.Toggle
                                                    as={Card.Header}
                                                    className={this.state.currentActiveKey == index.toString() ? "rm-chapter-header active" : "rm-chapter-header"}
                                                    eventKey={index}
                                                    onClick={() => this.toggle(index)}
                                                >
                                                    <span className='rm-chapter-title'>
                                                        <i className="fas fa-book-open mr-2"></i>
                                                        {item.chapter_name}
                                                    </span>
                                                    <span className='rm-chapter-meta'>
                                                        <span className='rm-file-count'>{item.filesData != null ? item.filesData.length : 0} files</span>
                                                        {this.state.currentActiveKey == index.toString() ? (
                                                            <i className="fas fa-chevron-up"></i>
                                                        ) : (
                                                            <i className="fas fa-chevron-down"></i>
                                                        )}
                                                    </span>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={index}>
                                                    <Card.Body>
                                                        {this.renderFilesGrid(item.filesData)}
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        )
                                    })
                                }
                            </Accordion>
                        )
                    ) : (
                        <Row className='mt-4'>
                            <Col sm={12}>
                                <div className='rm-empty-state'>
                                    <i className="fas fa-folder-open"></i>
                                    <h6>No revision materials available yet</h6>
                                </div>
                            </Col>
                        </Row>
                    )
                }
                </React.Fragment>
                )}

                <PDFModel show={this.state.modalShow} onHide={() => this.setState({ modalShow: false })} file_path={this.state.file_path} file_name={this.state.file_name} />

            </Container>
        )
    }
}
export default InstituteRevisionMaterialsHome;
